export class LogoWizardRequest {
   fileB64: string;
   emisorId: string;
   logoString: string; //for sendind LogoEmisorRequest  stringified
}
